import { LucideIcon } from 'lucide-react';
import { motion } from 'motion/react';

interface StatCardProps {
  title: string;
  value: string | number;
  icon: LucideIcon;
  gradient?: boolean;
}

export function StatCard({ title, value, icon: Icon, gradient = false }: StatCardProps) {
  return (
    <motion.div
      whileHover={{ y: -4, scale: 1.02 }}
      transition={{ type: 'spring', stiffness: 300 }}
      className={`bg-white rounded-2xl p-6 border transition-all cursor-pointer ${
        gradient
          ? 'border-blue-100 bg-gradient-to-br from-white to-blue-50/50 shadow-lg shadow-blue-100/50'
          : 'border-gray-100 shadow-sm hover:shadow-md'
      }`}
    >
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <p className="text-sm font-medium text-gray-600 mb-3">{title}</p>
          <p className="text-3xl font-semibold text-gray-900">{value}</p>
        </div>
        <div className="w-14 h-14 bg-gradient-to-br from-[#2563eb] to-[#1d4ed8] rounded-2xl flex items-center justify-center flex-shrink-0 shadow-lg shadow-blue-500/30">
          <Icon size={26} className="text-white" />
        </div>
      </div>
    </motion.div>
  );
}
